import { createSlice } from "@reduxjs/toolkit"

export const MenuSlice = createSlice({
    name: "menu",
    initialState: {
        menuState: false
    },
    reducers: {
        menuAction: (state, action) => {
            state.menuState = action.payload
        },
    }
})

export const { menuAction } = MenuSlice.actions;

export default MenuSlice.reducer;